export default {
    'name': 'check',
    'width': '16',
    'height': '16',
    'viewBox': '0 0 16 16',
    'data': '<path d=\'M13.5001 4.5001L6.50001 11.4998L2.99998 8.00013\' stroke=\'#42A463\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/>'
}
